module.exports = __webpack_public_path__ + "static/media/radio-csi.4008a62f.png";